import type { GoalType } from './apiRoutes';

type IndicatorLike = {
  goal_id?: number | null;
  acf?: { index?: string };
};

type GoalLike = {
  id: number;
  acf?: { index?: string };
};

/** Parse goal number from EU dataset code (e.g. sdg_07_10 → 7). */
export function extractGoalNumberFromEuCode(code: string): string {
  const match = (code || '').match(/sdg[_-](\d{1,2})/i);
  if (!match) return '';
  const n = parseInt(match[1], 10);
  return Number.isFinite(n) ? String(n) : '';
}

/** Normalize goal index to a comparable goal number string. */
export function normalizeGoalNumber(goalIndex: string): string {
  const digits = (goalIndex || '').replace(/[^0-9]/g, '');
  if (!digits) return '';
  const n = parseInt(digits, 10);
  return Number.isFinite(n) ? String(n) : digits;
}

/**
 * Whether an indicator belongs on a goal row.
 * UN: leading digits in indicator code (1.1.1). EU: goal_id, or sdg_XX in code (D-2 / IL-15 links).
 */
export function indicatorMatchesGoal(
  indicator: IndicatorLike,
  goal: GoalLike,
  goalType: GoalType
): boolean {
  if (indicator.goal_id && indicator.goal_id === goal.id) {
    return true;
  }

  const goalNumber = normalizeGoalNumber(goal.acf?.index || '');
  if (!goalNumber) return false;

  const code = indicator.acf?.index || '';

  if (goalType === 'eu') {
    const fromCode = extractGoalNumberFromEuCode(code);
    return fromCode !== '' && fromCode === goalNumber;
  }

  const unMatch = code.match(/^(\d+)/);
  const indicatorGoalNumber = unMatch ? normalizeGoalNumber(unMatch[1]) : '';
  return indicatorGoalNumber !== '' && indicatorGoalNumber === goalNumber;
}
